module.exports = new __parcel__URL__("eurobricks.ecfe9786.avif").toString();